import * as React from 'react';

import { getConfig } from '@constants';

import { getContainerHOC, renderChildren } from '@utils';

import { Translate } from '@decorators';

import { AppStat } from '@common/utils/AppStat';

import { IBrandChildProps, IBrandProps } from './types';

@Translate('common.containers.Brand')
export class Brand extends React.Component<IBrandProps> {

	componentDidMount() {
		AppStat.log.boom.openBoomBrand();
	}

	onDownloadButtonClick = () => {
		AppStat.log.boom.downloadBoomBrand();
	};

	onDownloadAllButtonClick = () => {
		AppStat.log.boom.downloadAllBoomBrand();
	};

	render() {
		const { children } = this.props;
		const {
			brand,
			hosts: {
				static: staticHost,
				staticExternal: staticExternalHost,
			},
			urls: {
				feedback,
			},
		} = getConfig();

		return renderChildren<IBrandChildProps>(children, {
			brand,
			urls: {
				feedback,
				brandDownload: `${staticExternalHost}/brand`,
				imagePath: `${staticHost}/static/brand`,
			},
			onDownloadButtonClick: this.onDownloadButtonClick,
			onDownloadAllButtonClick: this.onDownloadAllButtonClick,
		});
	}

}

export const withBrandContainer = getContainerHOC<IBrandProps, IBrandChildProps>(Brand);
